import * as _ from "lodash";

import { Nullable, readableHash } from "@ctra/utils";

import { EventListQueryParams, EventListQueryProps } from "./typings";
import { FarmEntity, SiteEntity } from "../farms";

/**
 * Make an event hash from the given farm id and optional params
 * @param {FarmEntity["id"]} farmID
 * @param {SiteEntity["id"]} siteID
 * @param {Partial<EventListQueryParams>} params
 * @returns {string}
 * @example
 * ```ts
 * makeEventHash(
 *   123,
 *   { source: "GenericInsights", startDate: 1234567890, endDate: 2345678901 }
 * );
 * // "836a4b19e5901e519a5713e812929e3ced6ef246"
 * ```
 */
export const makeEventHash = (
  farmID?: FarmEntity["id"],
  siteID?: Nullable<SiteEntity["id"]>,
  params?: Partial<EventListQueryProps>
): string =>
  readableHash({
    farmID,
    siteID,
    ...params
  });
